import { createSelector } from 'reselect';

import { editorSelector } from 'modules/editor/store/selectors/editor';

import { getPreview } from './utils';

export const previewSelector = createSelector(editorSelector, getPreview);
